import { Box, TextField, Tooltip, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const TextBox = ({ Icon, label, placeholder = "placeholder", value, onChange, onKeyDown, disabled = false, tooltip, type = "text" }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, width: 1 }}>
      <Box sx={{ display: "flex", gap: 0.75 }}>
        {Icon && (
          <Box sx={{}}>
            <Icon size={16} style={{ color: theme.palette.text.navigation, marginTop: "auto", marginBottom: "auto" }} />
          </Box>
        )}
        <Box sx={{ display: label ? "block" : "none" }}>
          <Tooltip title={t(tooltip || "")} arrow placement="right">
            <Typography variant="Textbox Label">{t(label)}</Typography>
          </Tooltip>
        </Box>
      </Box>
      <Box>
        <TextField
          sx={{ "& .MuiInputBase-input": { height: 14, paddingY: 1.25, paddingX: 1.5 }, "& .MuiOutlinedInput-root": { padding: 0 } }}
          fullWidth
          placeholder={t(placeholder)}
          variant="outlined"
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          onBlur={(e) => {
            if (type === "number") {
              const parsed = parseFloat(e.target.value);
              const finalValue = isNaN(parsed) ? "" : parsed;
              e.target.value = finalValue;
              onChange(e);
            }
          }}
          disabled={disabled}
        />
      </Box>
    </Box>
  );
};

export default TextBox;
